import getLocalString from "constants/Localization";
import { MenuItem } from "@mui/material";
import ActionConfirmDialog from "components/ActionConfirmDialog/ActionConfirmDialog";
import { EquipmentPiece } from "generated/graphql";
import { GlobalMessage } from "hooks/notifications/useGlobalMessage";
import useDeleteEquipmentPiece from "hooks/organization/useDeleteEquipmentPiece";
import useConfirmationDialog from "hooks/useConfirmationDialog";
import { useCallback } from "react";

export default function Delete({
  closeMenu,
  id,
}: {
  closeMenu: () => void;
  id: EquipmentPiece["id"];
}) {
  const [deleteEquipmentPiece, { isSuccess }] = useDeleteEquipmentPiece();

  const acceptFn = useCallback(async (): Promise<GlobalMessage> => {
    const { data } = await deleteEquipmentPiece({ id });

    if (isSuccess(data)) {
      closeMenu();
      return { message: getLocalString("organization.delete-equipment-piece-success") };
    } else {
      return {
        message: getLocalString("organization.delete-equipment-piece-failure"),
        options: { variant: "error" },
      };
    }
  }, [deleteEquipmentPiece, id]);

  const cancelFn = useCallback(async () => {
    closeMenu();
    return true;
  }, []);

  const { open, setOpen, onAccept, onCancel } = useConfirmationDialog({
    acceptFn,
    cancelFn,
  });

  return (
    <>
      <ActionConfirmDialog
        open={open}
        setOpen={setOpen}
        handleAccept={onAccept}
        handleCancel={onCancel}
        title="Confirmation"
        content="Are you sure you want to delete this equipment piece?"
      />
      <MenuItem onClick={() => setOpen(true)}>Delete</MenuItem>
    </>
  );
}
